import React from "react";
import { NodeStyle } from "../../atoms/node-style/NodeStyle";
import { WorkflowCustomCallbacks } from "../../atoms/workflow-custom-callbacks";

export const customNode = React.forwardRef(
  ({ node, children, ...otherProps }, ref) => {
    let defaultStyle = {
      minWidth: "185px",
      minHeight: "",
      backgroundColor: "#d6e9f2",
      borderRadius: "10px",
      color: "black",
      position: "absolute"
    };
    if (node.properties && node.properties.style) {
      const { style } = node.properties;
      for (const prop of Object.keys(style)) {
        if (prop !== "icon"&&prop!=="textStyle") {
          if (prop === "height" && style[prop] > 0) {
            defaultStyle.minHeight = style[prop];
          } else if (prop === "width" && style[prop] > 0) {
            defaultStyle.minWidth = style[prop];
          } else if (prop !== "width" && prop !== "height")
            defaultStyle[prop] = style[prop];
        }
      }
    }
    return (
      <WorkflowCustomCallbacks.Consumer>
        {callback => (
          <NodeStyle
            theme={defaultStyle}
            ref={ref}
            {...otherProps}
            onDoubleClick={() => {
              callback.editPropertyNode(node);
            }}
          >
            {children}
          </NodeStyle>
        )}
      </WorkflowCustomCallbacks.Consumer>
    );
  }
);
